// extracted by mini-css-extract-plugin
export default {"SignOut":"style_SignOut__dx5ej"};